module.exports = __webpack_public_path__ + "img/1479146786.c6053306.jpg";